<template>
  <div class="warp">
    <div class="warp1">
      <div class="top"></div>
      <div class="top_china" style="background:#fff;">
        <div class="top_china_cent">
          <div class="top_china_img" @click="logo()">
            <img src="../assets/img/top_logo.png" alt />
          </div>
          <div class="top_china-sc">
            <p>基于商会的一站式企业服务平台</p>
            <p>|</p>
            <div class="top_china_bot">
              <img src="../assets/img/top_slogan.png" alt />
            </div>
          </div>
        </div>
      </div>
      <div class="top_botm">
        <div class="top-botm_cent">
          <ul class="top-botm_ul">
            <li style="width: 150px; text-align: left; margin-left:0;" class="lii">
              <a href="#" style="font-size:16px">服务类目</a>
            </li>
            <router-link :to="{path:'/zhengwu'}" tag="li" style="margin-left: 58px;">
              <a href="#">政务政策</a>
            </router-link>
            <li @click="dialogVisible2 = true">
              <a href="#">商机人脉</a>
            </li>
            <li class="hover_li">
              <a href="#">解决方案</a>
              <div class="top_show">
                <div class="top_show_1">
                  <ul>
                    <li tag="li">
                      <p>
                        <a href="https://coc.sqifu.com">商会行业解决方案</a>
                      </p>
                      <p>
                        <a href="https://coc.sqifu.com">赋能商会信息化建设</a>
                      </p>
                    </li>
                    <li tag="li" @click="fuwushag()">
                      <p>
                        <a href="#">企服行业解决方案</a>
                      </p>
                      <p>
                        <a href="#">助力企业决胜互联网+时代</a>
                      </p>
                    </li>
                    <li tag="li">
                      <p>
                        <a href="https://zf.sqifu.com">政企行业解决方案</a>
                      </p>
                      <p>
                        <a href="https://zf.sqifu.com">民营企业服务平台建设运营</a>
                      </p>
                    </li>
                    <li tag="li"  @click="waibao()">
                      <p>
                        <a href="#">一站式定制开发解决方案</a>
                      </p>
                      <p>
                        <a href="#">应用类软件定制化开发服务</a>
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <router-link :to="{path:'/guanyu'}" tag="li">
              <a href="#">关于商企服</a>
            </router-link>
            <!-- <router-link :to="{path:'/hezuo'}" tag="li">
              <a href="#">合作代理</a>
            </router-link> -->
          </ul>
        </div>
      </div>
    </div>
    <div class="banner">
      <div class="banner_1">
        <div class="top_hover">
          <div class="leimu" v-for="(item, index) in lists" :key="index" v-if="index<7">
            <p class="lianjie" @click="fuclick(item.id,item.category_name)">
              <a href="#">{{item.category_name}}</a>
            </p>
            <i class="el-icon-arrow-right"></i>
            <div class="top_hover_block">
              <div class="top_hover_1" v-for="(item,index) in item.list" :key="index">
                <p>
                  <a href="#">{{item.category_name}}</a>
                </p>
                <ul>
                  <li v-for="(item,index) in item.list" :key="index">
                    <a href="#" @click="fuclick(item.id,item.category_name)">{{item.category_name}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="login">
          <div class="login_1">
            <img
              src="../assets/img/login_icon_head.png"
              alt
              style="width: 54px; height: 54px;margin:39px 0 0 98px; border-radius:50px;"
              v-if="this.photo == ''"
            />
            <img
              :src="this.photo"
              alt
              style="width: 54px; height: 54px;margin:39px 0 0 98px; border-radius:50px;"
              v-else
            />
            <p>{{login_name}}</p>
            <p style="line-height:20px;color:#666666;font-size:12px;">Hi，欢迎来到商企服</p>
            <p style="line-height:0;" class="login_p1">
              <router-link :to="{name:'geren',query:{token:this.$route.query.token}}" tag="a">个人中心</router-link>
            </p>
          </div>
          <div class="login_2" v-if="this.is_service == 2">
            <div class="login_4">
              <img src="../assets/img/login_icon_fws.png" alt style="width:16px;height:16px;" />
            </div>
            <div class="login_3">
              <span>加入平台成为服务商</span>
              <a href="#" style="float:right;color: #007BFF" @click="settled()">
                立即入驻
                <i class="el-icon-arrow-right"></i>
              </a>
            </div>
          </div>
          <div class="login_5">
            <img
              src="../assets/img/news_icon_title.png"
              alt
              style="width:38px; height:18px; margin:8px 0 0 9px"
            />
            <div class="login_6">
              <p
                v-for="(item,index) in getartic"
                :key="index"
                v-if="index<4"
                @click="details(item.id)"
              >
                <a href="#">{{item.title}}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <el-carousel :interval="5000" arrow="never" height="426px" style="z-index:-1">
        <el-carousel-item v-for="(item,index) in imgg" :key="index">
          <div class="img_z">
            <!-- <div class="banner_p">
              <p style="font-size:28px;font-weight:400;">基于商会的一站式企业服务平台</p>
              <p>已获得200万种子轮融资，目前已经入驻商会50余家，并与天津市河西区、天津市河东区、甘肃省庆阳市等工商联达成战略合作。</p>
              <p>
                <a href="#">立即了解</a>
              </p>
            </div>-->
            <img :src="item.url" alt />
          </div>
        </el-carousel-item>
        <!-- <el-carousel-item>
          <div class="img_z"></div>
          <img src="../assets/img/home_banner_02.png" alt />
        </el-carousel-item>-->
      </el-carousel>
      <div class="cent_fuwu_china1">
        <div class="cent_fuwu_china11">
          <div class="cent_fuwu_china1_01" @click="whole()">
            <img src="../assets/img/service_btn_all.png" style="width:18px;height:18px;" alt />
            <p>
              <a href="#">查看全部</a>
            </p>
          </div>
          <div class="cent_fuwu_china1_02">
            <img src="../assets/img/process_img.png" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="cent_fuwu">
      <div class="cent_fuwu_china">
        <div class="cent_fuwu_china2">
          <div class="cent_fuwu_china2_01">
            <img src="../assets/img/popular_icon_sign.png" alt />
          </div>
          <div class="cent_fuwu_china2_02" v-for="(item,index) in getPchoem" :key="index">
            <div class="cent_fuwu_china2_021">
              <div class="cent_fuwu_china2_022">
                <div class="cent_fuwu_china2_023">
                  <p style="font-size:22px;font-weight:600;">{{item.name}}</p>
                  <p style="font-size:14px; color:#999999; margin-top:5px;">{{item.content}}</p>
                </div>
                <div class="cent_fuwu_china2_024">
                  <img src="../assets/img/popular_icon_01.png" v-show="index == 0" alt />
                  <img src="../assets/img/popular_icon_02.png" v-show="index == 1" alt />
                  <img src="../assets/img/popular_icon_03.png" v-show="index == 2" alt />
                </div>
              </div>
              <div class="cent_fuwu_china2_025">
                <ul>
                  <li v-for="(item,index) in item.list" :key="index" @click="idem(item.id)">
                    <a href="#">{{item.category_name}}</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cont">
      <div class="cont_1">
        <h1>为您推荐</h1>
        <div
          class="cont_content01"
          v-for="(item,index) in onelist"
          :key="index"
          style="margin-bottom: 30px;"
        >
          <div class="cont_content01_img">
            <img src="../assets/img/recommend_img_01.png" alt v-show="index==0" />
            <img src="../assets/img/recommend_img_02.png" alt v-show="index==1" />
            <img src="../assets/img/recommend_img_03.png" alt v-show="index==2" />
            <img src="../assets/img/recommend_img_03(1).png" alt v-show="index==3" />
            <div class="cont_content02" @click="shangping(item.id)">
              <p style="font-size:22px; font-weight:600;">{{item.category_name}}</p>
              <p class="description">{{item.qualification_description}}</p>
              <p>
                <a
                  href="#"
                  style="width:72px;height:28px;border:1px solid #fff;text-align:center;line-height:28px;"
                >立即查看</a>
              </p>
            </div>
          </div>
          <ul class="cont-content02">
            <li
              style="border-right: 1px solid #E5E8ED;"
              v-for="(item,index) in item.goods.data"
              :key="index"
              @click="idemthree(item.id)"
              v-if="index<6"
            >
              <div class="cont_content_li">
                <p style="font-weight:600;">{{item.category_name}}</p>
                <p class="p2">{{item.providers_name}}</p>
                <p class="p3">
                  ￥{{item.price}}
                  <span style="font-size:12px;color:#666666;">起</span>
                </p>
                <p class="p4">
                  <img src="../assets/img/service_btn_go_pre.png" alt />
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="cont_botm">
      <div class="cont_botm01">
        <h1>优质服务商</h1>
        <div class="cont_botm001">
          <ul class="cont_botm02">
            <li
              v-for="(item,index) in getmanage"
              :key="index"
              @click="provider(item.id)"
              v-if="index<6"
            >
              <div class="cont-botm02_li">
                <div class="cont_botm_left">
                  <img :src="item.avatar" alt />
                </div>
                <div class="cont_botm_right">
                  <p>{{item.providers_name}}</p>
                  <p class="cont_botm_right_P">
                    <a
                      href="#"
                      v-for="(item,index) in item.categorys"
                      :key="index"
                    >{{item.category_name}}</a>
                  </p>
                </div>
              </div>
              <div class="cont-botm02_li1">
                <p>
                  <a href="#" style="color:#fff">免费咨询</a>
                </p>
              </div>
            </li>
          </ul>
          <div class="cont_botm03" @click="settled()">
            <img src="../assets/img/settled in.png" alt />
          </div>
        </div>
      </div>
    </div>
    <div class="cont_botm_1">
      <img src="../assets/img/bottom_bg_guarantee.png" alt />
    </div>
    <div class="floor">
      <div class="floor_china">
        <div class="floor_china_1">
          <ul style="margin-left: 0;">
            <p>关于我们</p>
            <li style="margin-top: 24px;">
              <a href="#" @click="about()">关于商企服</a>
            </li>
            <li>
              <a href="#" @click="about()">奖项荣誉</a>
            </li>
            <li>
              <a href="#" @click="about()">商企资讯</a>
            </li>
            <li>
              <a href="#" @click="about()">联系我们</a>
            </li>
          </ul>
          <ul>
            <p>我要入驻</p>
            <li style="margin-top: 24px;" @click="fuwushang()">
              <a href="#">服务商入驻</a>
            </li>
            <li>
              <a href="#" @click="shanghui()">商会入驻</a>
            </li>
            <!-- <li @click="hezuo()">
              <a href="#">代理商合作</a>
            </li> -->
          </ul>
          <ul>
            <p>服务&支持</p>
            <li style="margin-top: 24px;">
              <a href="https://www.aliyun.com/?utm_content=se_1002986587">阿里云</a>
            </li>
            <li>
              <a href="https://cloud.tencent.com/?fromSource=gwzcw.330897.330897.330897">腾讯云</a>
            </li>
            <li>
              <a href="https://c.qq.com/">腾讯创业服务平台</a>
            </li>
          </ul>
        </div>
        <div class="floor_china_2">
          <img src="../assets/img/bottom_logo_blue.png" alt />
          <span>/ 基于商会的一站式企业服务平台</span>
          <p>免费为商业服务类公司提供线上智能化CRM系统及B2B商城，以其强大的商会会员流量体系帮助企业服务类公司进行拓客。</p>
        </div>
      </div>
    </div>
    <div class="floor_1">
      <p>
        <span><a href="http://beian.miit.gov.cn"  target="_blank" style='color:#85919a'>津ICP备19005305号</a></span>
        <img src="../assets/img/bottom_icon_filing.png" alt style="margin-top:5px;" />
        <span><a href="http://www.beian.gov.cn"  target="_blank" style='color:#85919a'>公安网备案12010302001745号</a></span>
      </p>
    </div>
    <!--  -->
    <div class="dingbu">
      <div class="dingbu_img">
        <img
          src="../assets/img/hover_btn_xcx.png"
          alt
          class="dingbu_img_1"
          v-show="seen&&index==current"
        />
        <img
          src="../assets/img/hover_btn_app.png"
          alt
          class="dingbu_img_2"
          v-show="seen1&&index==current1"
        />
        <img
          src="../assets/img/hover_btn_gzh.png"
          alt
          class="dingbu_img_3"
          v-show="seen2&&index==current2"
        />
        <img
          src="../assets/img/hover_btn_tel.png"
          alt
          class="dingbu_img_4"
          v-show="seen3&&index==current3"
        />
      </div>
      <ol class="dingbu_1">
        <li @mouseenter="lever(index)" @mouseleave="leve()">
          <a href="#">小程序</a>
        </li>
        <li @mouseenter="lever1(index)" @mouseleave="leve1()">
          <a href="#">下载APP</a>
        </li>
        <li @mouseenter="lever2(index)" @mouseleave="leve2()">
          <a href="#">公众号</a>
        </li>
        <li style="border:0;" class="ol_li" @click="toTop">
          <img src="../assets/img/hover_btn_top_nor.png" alt class="img_block" />
          <img src="../assets/img/hover_btn_top_pre(1).png" alt class="img_none" />
        </li>
        <li class="dingbu_2" @mouseenter="lever3(index)" @mouseleave="leve3()">
          <!-- <img src="../assets/img/hover_btn_top_pre.png" alt=""> -->
          <img src="../assets/img/hover_btn_kf_nor.png" alt class="img_block" />
          <img src="../assets/img/hover_btn_top_pre.png" alt class="img_none" />
          <p href="#">客服</p>
        </li>
      </ol>
    </div>

     <el-dialog :visible.sync="dialogVisible2" width="50%">
      <div class="dialog">
        <img src="../assets/img/geren/pop_QR.png" alt />
        <p>请前往小程序进行操作</p>
      </div>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import { getRegionList, getLogout, createOrder } from "@/http/api";
export default {
  data() {
    return {
      dialogVisible2:false,
      current: 0,
      seen: 0,
      current1: 0,
      seen1: 0,
      current2: 0,
      seen2: 0,
      current3: 0,
      seen3: 0,
      index: 0,
      dialogVisible: false,
      num: 0,
      lists: [],
      listss: [],
      login_name: "",
      getartic: [],
      onelist: [],
      dialogVisible3: false,
      formLogon: {
        phone: "",
        ecord: ""
      },
      show: true,
      cang: false,
      TIME_COUNT: 60, //验证码倒计时60s，
      count: "",
      options: [],
      getmanage: [],
      hot: [],
      props: {
        toBottom: {
          type: Number,

          default: 0
        }
      },
      imgg: [],
      getPchoem: []
    };
  },
  methods: {
    //划过
    lever() {
      this.seen = true;
      this.current = false;
    },
    leve() {
      this.seen = true;
      this.current = null;
    },
    lever1() {
      this.seen1 = true;
      this.current1 = false;
    },
    leve1() {
      this.seen1 = true;
      this.current1 = null;
    },
    lever2() {
      this.seen2 = true;
      this.current2 = false;
    },
    leve2() {
      this.seen2 = true;
      this.current2 = null;
    },
    lever3() {
      this.seen3 = true;
      this.current3 = false;
    },
    leve3() {
      this.seen3 = true;
      this.current3 = null;
    },
    // 跳转
    getCategoryList() {
      var that = this;
      that
        .$http("https://ctapi.sqifu.com/api/v1/getCategoryList", {}, "POST")
        .then(res => {
          that.lists = res.data.data;
          that.listss = res.data.data.list;
        });
    },
    //退出登录
    getlogout() {
      getLogout({}).then(res => {
        this.$message({
          message: "退出登录"
        });
        this.$router.push({ name: "login" });
      });
    },
    personal() {
      this.$route.push({ path: "/geren" });
    },
    getArticleRecommend() {
      this.id = localStorage.getItem("city_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getArticleRecommend",
        { city_id: this.id },
        "post"
      ).then(res => {
        this.getartic = res.data.data.data;
      });
    },
    getOneCategoryList() {
      this.id = localStorage.getItem("city_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getPcHoemRecommendCategory",
        {
          city_id: this.id
        },
        "post"
      ).then(res => {
        this.onelist = res.data.data;
      });
    },
    shangping(id) {
      this.$router.push({
        name: "fuwu",
        query: {
          id: id
        }
      });
    },
    getCode1() {
      if (!this.timer) {
        this.count = this.TIME_COUNT;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= this.TIME_COUNT) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    //服务商
    hezuo() {
      this.$router.push({
        name: "hezuo"
      });
    },
    shanghui() {
      this.$router.push({
        name: "shanghuiruzha"
      });
    },
    fuwushang() {
      this.$router.push({
        name: "settled"
      });
    },
    about() {
      this.$router.push({
        name: "guanyu"
      });
    },
    honor() {
      this.$router.push({
        name: "guanyu",
        query: {
          numm: 1
        }
      });
    },
    provider(id) {
      this.$router.push({
        name: "fuwu",
        query: {
          provider_id: id
        }
      });
    },
    whole() {
      this.$router.push({
        name: "fuwu"
      });
    },

    GetManagement() {
      this.id = localStorage.getItem("city_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/GetManagement_ProviderPass",
        {
          city_id: this.id
        },
        "post"
      ).then(res => {
        this.getmanage = res.data.data;
      });
    },
    getHot() {
      this.id = localStorage.getItem("city_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getTwoCategoryList",
        {
          pid: 0,
          city_id: this.id
        },
        "post"
      ).then(res => {
        this.hot = res.data.data.data;
      });
    },
    idem(id) {
      this.$router.push({
        name: "fuwu",
        query: {
          id: id
        }
      });
    },
    idemthree(id) {
      this.$router.push({
        name: "fuwuxiang",
        query: {
          id: id
        }
      });
    },
    tijiap() {
      this.token = localStorage.getItem("token");
      createOrder({
        token: this.token,
        goods_price: "",
        goods_id: "",
        provider_id: "",
        goods_price: "",
        demand_title: "",
        remark_member: ""
      }).then(res => {
      });
    },
    settled() {
      this.$router.push({
        name: "settled"
      });
    },
    logo() {
      this.$router.push({
        name: "home"
      });
    },
    details(id) {
      this.$router.push({
        name: "article",
        query: {
          city_id: id
        }
      });
    },
    toTop() {
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    getPageBannerBycityId() {
      this.id = localStorage.getItem("city_id");
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getPageBannerByCityId",
        {
          city_id: this.id
        },
        "post"
      ).then(res => {
        this.banner_img = res.data.data.HomeBanner;
        this.imgg = JSON.parse(this.banner_img);
      });
    },
    waibao() {
      this.$router.push({
        name: "waibao"
      });
    },
    fuwushag(){
      this.$router.push({
        name: "fuwushang"
      });
    },
    //热门服务
    getPcHoem() {
      this.$http(
        "https://ctapi.sqifu.com/api/v1/getPcHoemCategory",
        {},
        "post"
      ).then(res => {
        this.getPchoem = res.data.data;
      });
    },
    fuclick(id, category_name) {
      this.$router.push({
        name: "fuwu",
        query: {
          id: id,
          category_name: category_name
        }
      });
    }
  },
  created() {
    this.getCategoryList();
    this.login_name = localStorage.getItem('name');
    this.login_img = this.$route.query.idimg;
    this.getArticleRecommend();
    this.getOneCategoryList();
    this.$emit("header", true);
    // this.getTwoCategorylist();
    this.photo = localStorage.getItem("photo");
    this.is_service = localStorage.getItem("is_service");
    this.GetManagement();
    this.getHot();
    this.getPageBannerBycityId();
    this.getPcHoem();
  }
};
</script>

<style scoped>
@import "../components/style.css";
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
}

.tools-btn {
  width: 100%;
  margin: 30px auto;
  overflow: hidden;
  margin-top: 24px;
}

.dialog_top {
  width: 100%;
  height: 60px;
  background: #f4f5f9;
  text-align: center;
  line-height: 60px;
}

.dialog_top p {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: rgba(34, 34, 34, 1);
}

.dialog_cent {
  width: 85%;
  height: 118px;
  margin: 0 auto;
}

.dialog_cent_1 {
  width: 100px;
  height: 40px;
  float: left;
  line-height: 32px;
  font-size: 14px;
}

.xiala1 {
  width: 190px;
  height: 38px;
  float: left;
}

.inpp {
  width: 480px;
  height: 96px;
}

.inppp {
  width: 500px;
  height: 60px;
  float: left;
}

.inpt {
  width: 190px;
}

.inppp p {
  margin-top: 5px;
  color: #f7681eff;
  font-size: 12px;
}

.code-btn {
  width: 100px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 5px;
  z-index: 222;
  color: #007bff;
  font-size: 14px;
  border: none;
  border-left: 1px solid #bababa;
  padding-left: 10px;
  background-color: #fff;
  cursor: pointer;
  outline: none;
}
.pr {
  width: 275px;
  margin-bottom: 20px;
  float: left;
  margin-right: 10px;
}

.pr1 {
  width: 196px;
  margin-bottom: 20px;
  float: left;
}

.input1 {
  width: 275px;
}

.input2 {
  width: 196px;
}

.botton1 {
  width: 180px;
  height: 44px;
  margin: 0 0 0 280px;
  margin-top: 34px;
  font-size: 12px;
  background: #007bffff;
  outline: 0;
  border: 0;
  margin-bottom: 30px;
}

.banner_1 {
  width: 1200px;
  height: 426px;
  position: absolute;
  left: 50%;
  margin-left: -600px;
}

.banner img {
  width: 100%;
  height: 426px;
}

.lii {
  height: 40px;
  background: #0812d8;
}

.cent_fuwu {
  width: 100%;
  background: #f5f6fa;
  overflow: hidden;
}

.cent_fuwu_china {
  width: 1200px;
  height: 206px;
  margin: 0 auto;
  background: #fff;
  margin-bottom: 60px;
}

.cent_fuwu_china1 {
  width: 100%;
  height: 73px;
  background: #f5f6fa;
}

.cent_fuwu_china11 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}

.cent_fuwu_china1_01 {
  width: 150px;
  height: 73px;
  background: #323445;
  float: left;
}

.cent_fuwu_china1_01 img {
  float: left;
  padding: 27px 10px 27px 20px;
}

.cent_fuwu_china1_01 p a {
  font-size: 18px;
  color: #fff;
  float: left;
  padding: 25px 0;
}

.cent_fuwu_china1_02 {
  width: 1040px;
  height: 64px;
  background: #e5e8ed;
  float: right;
  margin: 10px 0 0 0;
}

.cent_fuwu_china1_02 img {
  width: 100%;
  height: 100%;
}

.cent_fuwu_china2 {
  width: 100%;
  height: 206px;
  margin-top: 50px;
}

.cent_fuwu_china2_01 {
  width: 230px;
  float: left;
}

.cent_fuwu_china2_02 {
  width: 323px;
  height: 206px;
  float: left;
}

.cent_fuwu_china2_021 {
  width: 100%;
  height: 179px;
  border-right: 1px solid #cacaca;
  margin: 20px 0;
  overflow: hidden;
  /* background: #fff; */
}

.cent_fuwu_china2_022 {
  width: 290px;
  height: 54px;
  margin: 5px 0 0 16px;
  overflow: hidden;
}

.cent_fuwu_china2_023 {
  float: left;
}

.cent_fuwu_china2_024 {
  float: right;
}

.cent_fuwu_china2_025 {
  width: 290px;
  height: 60px;
  margin: 35px 0 0 12px;
}

.cent_fuwu_china2_025 ul li a {
  width: 80px;
  height: 20px;
  float: left;
  margin: 6px 0 0 12px;
  border: 1px solid #576778;
  border-radius: 25px;
  font-size: 14px;
  text-align: center;
  color: #222222;
}

.cent_fuwu_china2_025 ul li a:hover {
  background: #007bff;
  color: #fff;
  border: 1px solid #007bff;
}

.cont {
  width: 100%;
}

.cont_1 {
  width: 1200px;
  height: auto;
  margin: 0 auto;
}
.cont_1 h1,
.cont_botm01 h1 {
  margin: 40px 0 0 0;
}

.cont_content01 {
  width: 100%;
  height: 351px;
  border: 1px solid #eeeeee;
  margin-top: 30px;
}

.cont_content01_img {
  width: 260px;
  height: auto;
  float: left;
  position: relative;
}

.cont_content02 {
  width: 170px;
  height: 200px;
  position: absolute;
  top: 3%;
  left: 26%;
}

.cont_content02 p,
.cont_content02 p a {
  color: #fff;
  font-size: 14px;
  float: right;
  margin-top: 20px;
  margin-right: 1px;
}

.description{
  width: 164px;
  height: 31px;
}

.cont-content02 {
  width: 940px;
  height: 351px;
  float: left;
}

.cont-content02 li {
  width: 312px;
  height: 175px;
  float: left;
}

.cont_content_li {
  width: 270px;
  height: 140px;
  margin: 20px;
}

.cont-content02 li:hover {
  color: #ffffff !important;
  display: block !important;
  background: linear-gradient(90deg, rgba(90, 103, 121, 1), rgba(0, 0, 2, 1));
  opacity: 0.9;
}

.cont-content02 li:hover p {
  color: #ffffff !important;
  display: block !important;
}

.p4 {
  float: right;
  margin-top: 42px;
  display: none;
}

.p3 {
  color: #f43f2d;
  float: left;
  margin-top: 42px;
}

.p2 {
  font-size: 14px;
  color: #999999;
  margin-top: 10px;
}

.cont_botm {
  width: 100%;
  background: #f5f6fa;
}

.cont_botm01 {
  width: 1200px;
  height: 661px;
  margin: 0 auto;
  overflow: hidden;
}

.cont_botm001 {
  width: 100%;
  height: auto;
  margin-top: 20px;
}

.cont_botm02 {
  width: 880px;
  height: 502px;
  float: left;
}

.cont_botm03 {
  width: 320px;
  height: 502px;
  float: left;
}

.cont_botm02 li {
  width: 420px;
  height: 154px;
  background: #fff;
  float: left;
  /* margin: 20px 20px 0 0; */
  position: relative;
}
.cont_botm02 li:nth-child(n + 2) {
  margin: 0 20px 0 0;
}

.cont_botm02 li:nth-child(1) {
  margin: 0 20px 0 0;
}

.cont_botm02 li:nth-child(3),
.cont_botm02 li:nth-child(4),
.cont_botm02 li:nth-child(5),
.cont_botm02 li:nth-child(6) {
  margin: 20px 20px 0 0;
}
.cont-botm02_li {
  width: 320px;
  height: 68px;
  margin: 30px 0 0 30px;
}

.cont_botm_left {
  width: 68px;
  height: 68px;
  float: left;
}

.cont_botm_left img {
  width: 68px;
  height: 68px;
  border-radius: 50px;
}

.cont_botm_right {
  width: 236px;
  float: right;
}

.cont_botm_right_P {
  margin-top: 10px;
}

.cont_botm_right_P a {
  width: 84px;
  height: 26px;
  border: 1px solid #e5e8ed;
  margin-left: 6px;
  font-size: 14px;
  color: #666666;
}

.cont-botm02_li1 {
  width: 97px;
  height: 44px;
  background: #007bff;
  border-top-left-radius: 30px;
  position: absolute;
  bottom: 0;
  right: 0;
}

.cont-botm02_li1 p {
  font-size: 14px;
  text-align: center;
  line-height: 44px;
}

.cont_botm_1 {
  width: 100%;
  height: 140px;
}

.cont_botm_1 img {
  width: 100%;
  height: 100%;
}

.floor {
  width: 100%;
  background: #2d3236;
}

.floor_china {
  width: 1200px;
  height: 224px;
  margin: 0 auto;
  overflow: hidden;
}

.floor_china_1 {
  width: 750px;
  height: 104px;
  border-right: 1px solid #85919a;
  margin: 60px 0 0 0;
  float: left;
}

.floor_china_1 ul {
  float: left;
  margin-left: 180px;
}

.floor_china_1 li a {
  color: #85919a;
  font-size: 14px;
}

.floor_china_1 p {
  color: #fff;
}

.floor_china_2 {
  width: 365px;
  height: 104px;
  float: right;
  margin: 60px 0 0 0;
}

.floor_china_2 span {
  color: #ffffff;
  font-size: 14px;
}

.floor_china_2 p {
  color: #85919a;
  font-size: 14px;
  margin-top: 21px;
}

.top_hover {
  width: 150px;
  height: 426px;
  background: #323445;
  position: absolute;
}

.floor_1 {
  width: 100%;
  height: 56px;
  background: #efefef;
}

.floor_1 p {
  text-align: center;
  line-height: 56px;
  color: #85919a;
  font-size: 14px;
}

.leimu {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #414354;
}

.lianjie {
  width: 73px;
  height: 18px;
  text-align: left;
  margin: 21px 0;
  margin-left: 20px;
  color: #fff;
  text-align: center;
  line-height: 19px;
  font-size: 18px;
  float: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.lianjie a {
  color: #fff;
}

.leimu i {
  width: 6.3px;
  height: 12px;
  float: right;
  padding: 23px 20px;
  color: #fff;
}

.top_hover_block {
  width: 522px;
  height: 499px;
  background: #fff;
  position: absolute;
  top: 0;
  left: 150px;
  display: none;
}
.leimu:hover {
  background: #fff;
  color: #007bff;
}

.leimu:hover i {
  color: #007bff;
}

.leimu:hover .lianjie a {
  color: #007bff;
}

.leimu:hover .top_hover_block {
  display: block;
}

.lii a {
  margin: 0 0 0 30px;
  color: #fff;
  font-size: 14px;
}

.warp {
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
}

.top {
  width: 100%;
  height: 40px;
  background: #f5f6fa;
  position: fixed;
}

.top_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}

.top_cent_p {
  font-size: 14px;
  color: #007bff;
  line-height: 40px;
  float: left;
}

.icon {
  color: #000;
}

.top_ul {
  width: 568px;
  height: auto;
  float: right;
  display: flex;
}

.top_ul li {
  font-size: 14px;
  line-height: 40px;
  color: #666666;
  margin-left: 39px;
  float: right;
}

.top_china {
  width: 100%;
  overflow: hidden;
  margin-top: 40px;
}

.top_china_cent {
  width: 1200px;
  margin: 0 auto;
}

.top_china_img {
  padding: 19px 0;
  float: left;
}

.top_china_scout {
  width: 448px;
  height: 44px;
  background: #007bff;
  float: left;
  margin: 19px 0;
  border-radius: 5px;
  margin-right: 11px;
}

.input {
  width: 348px;
  height: 38px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  outline: none;
  border: 0;
  margin: 3px 0 0 3px;
  font-size: 16px;
  float: left;
  color: #c7c7c7;
}

.btn {
  width: 97px;
  height: 44px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  outline: none;
  border: 0;
  background: #007bff;
  font-size: 16px;
  color: #fff;
}
.top_china_bot {
  width: 150px;
  height: 44px;
  float: left;
  margin-top: 40px;
}

.top_china-sc {
  float: right;
}

.top_china-sc p {
  float: left;
  line-height: 104px;
  padding: 0 10px;
  font-size: 14px;
  color: #b2b2b2;
}

.butoon {
  width: 150px;
  height: 44px;
  margin: 19px 0;
  background: #f7681e;
  outline: 0;
  border: 0;
  font-size: 16px;
}

.top_china-sc {
  float: right;
}

.top_botm {
  width: 100%;
  height: 40px;
  background: #005aff;
}

.top-botm_cent {
  width: 1200px;
  height: 40px;
  margin: 0 auto;
}
.top-botm_ul li {
  width: 100px;
  height: 40px;
  float: left;
  margin-left: 40px;
  line-height: 40px;
  text-align: center;
}

.top-botm_cent ul li a {
  color: #fff;
  font-size: 16px;
}

.top-botm_ul li:hover {
  background: #0812d8;
}

.banner {
  width: 100%;
  height: 499px;
  position: relative;
  overflow: hidden;
}
.warp1 {
  width: 100%;
  margin: 0 auto;
  z-index: 1;
  overflow: hidden;
  min-width: 1200px;
  background: #fff;
}

.login {
  width: 250px;
  height: 382px;
  float: right;
  margin: 20px 0 20px 0;
}

.login_1 {
  width: 100%;
  height: 205px;
  background: #ffffff;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
}

.login_1 p {
  text-align: center;
  line-height: 40px;
}

.login_1 a {
  text-align: center;
  line-height: 24px;
  color: #007bff;
  font-size: 14px;
}

.login_img {
  margin-left: 45px;
}

.login_p1 {
  width: 78px;
  height: 24px;
  background: #007bff;
  border-radius: 25px;
  margin: 10px auto;
}

.login_p1 a {
  color: #fff;
}

.login_2 {
  width: 100%;
  height: 40px;
  background: #efefef;
}

.login_2 span,
.login_2 a {
  font-size: 14px;
  line-height: 40px;
  float: left;
}

.login_2 img {
  margin: 12px 0 0 11px;
}

.login_4 {
  float: left;
}

.login_5 {
  width: 100%;
  height: 137px;
  background: #1b2a3f;
  margin-top: 4px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.login_6 {
  width: 217px;
  height: 101px;
  margin: 1px auto;
}

.login_6 p {
  font-size: 14px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 3px;
  color: #cdd0d5;
}

.login_6 p a {
  color: #cdd0d5;
  font-size: 14px;
  line-height: 20px;
}

.login_6 p a:hover {
  color: #007bff;
}

.dingbu {
  width: 260px;
  height: 300px;
  position: fixed;
  right: 20px;
  bottom: 100px;
}

.dingbu_1 {
  width: 50px;
  height: 300px;
  border-radius: 5px;
  overflow: hidden;
  float: right;
}

.dingbu_img {
  position: relative;
}

.dingbu_img_1 {
  position: absolute;
  top: -70px;
}

.dingbu_img_2 {
  position: absolute;
  top: -10px;
}

.dingbu_img_3 {
  position: absolute;
  top: 50px;
}

.dingbu_img_4 {
  position: absolute;
  top: 230px;
}

.dingbu_1 li {
  padding: 10px;
  border-bottom: 1px solid #e5e8ed;
  font-size: 14px;
  text-align: center;
  background: #fff;
}

.dingbu_1 li a {
  width: 38px;
  height: 19px;
  color: #666666;
}

.dingbu_2 {
  height: 60px;
  margin-top: 10px;
  border-radius: 5px;
}

.dingbu_2 p {
  font-size: 14px;
  color: #007bff;
  line-height: 10px;
}

.dingbu_2 img {
  width: 24px;
  height: 24px;
  margin: 0px 0 0 3px;
}

.ol_li img {
  width: 25px;
  height: 25px;
  margin: 10px 0 0 3px;
}

.top_show {
  width: 100%;
  height: 280px;
  background: #fff;
  position: absolute;
  top: 184px;
  left: 0;
  display: none;
  z-index: 1;
}

.hover_li:hover .top_show {
  display: block;
}

.top_show_1 {
  width: 700px;
  height: 164px;
  margin: 34px auto;
}

.top_show_1 li {
  width: 220px;
  height: 72px;
  float: left;
  margin: 10px 0 0 10px;
  border-radius: 4px;
  line-height: 25px;
}

.top_show_1 li:hover {
  background: #f4f5f9ff;
}

.top_show_1 li p a {
  /* padding: 5px 5px 0 5px; */
  font-size: 14px;
  color: #999999ff;
  text-align: left;
}

.top_show_1 li p:first-child {
  border-left: 5px solid #007bff;
  border-radius: 0;
  margin: 10px 0 10px 0;
}

.top_show_1 li p:first-child a {
  width: auto;
  height: 19px;
  font-size: 18px;
  color: #222222ff;
  margin: 10px 0 10px 0;
  text-align: left;
}

.img_z {
  position: relative;
}

.img_z img {
  width: 100%;
}

.banner_p {
  width: 519px;
  height: 245px;
  position: absolute;
  left: 40%;
  top: 30%;
  transform: translate(-35%, -20%);
  max-width: 50%;
  /* text-align: center; */
}

.banner_p p {
  color: #fff;
  margin-top: 31px;
}

.banner_p p:first-child {
  margin: 0;
}

.banner_p p:last-child {
  width: 140px;
  height: 40px;
  border: 1px solid #fff;
  margin-top: 60px;
  text-align: center;
}

.banner_p p:last-child a {
  color: #fff;
  text-align: center;
  line-height: 40px;
}

.top_hover_1 {
  width: 220px;
  height: 100px;
  margin: 25px 0 0 30px;
  float: left;
}

.top_hover_1 p {
  font-weight: bold;
  border-bottom: 1px solid #efefef;
  display: block;
  margin-bottom: 5px;
}

.top_hover_1 p a {
  color: #007bff;
  font-family: PingFang SC;
  padding: 0 8px;
}

.top_hover_1 ul {
  width: 220px;
  height: 80px;
}

.top_hover_1 ul li a {
  float: left;
  font-size: 12px;
  padding: 5px 8px;
  color: #222;
}

.top_hover_1 ul li a:hover {
  color: #007bff;
}

.dingbu_img {
  float: left;
}

.img_none {
  display: none;
}

.dingbu_1 li:hover {
  background: #007bff;
}

.dingbu_1 li:hover .img_block {
  display: none;
}

.dingbu_1 li:hover .img_none {
  display: block;
}

.dingbu_1 li:hover a,
.dingbu_1 li:hover p {
  color: #fff;
}

.login1 {
  width: 340px;
  height: 50px;
  margin: 0 auto;
}

.login1 div {
  width: 170px;
  height: 40px;
  font-size: 18px;
  float: left;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #e4e4e4;
}

.login1 div a {
  color: #a9a9a9;
}

.login1 div.active {
  border-bottom: 2px solid #007bff;
}

.login1 div.active a {
  color: #007bff;
}

.login1_1 {
  width: 100%;
  height: 399px;
  position: relative;
  overflow: hidden;
}

.login1_img {
  position: absolute;
  right: 0;
  bottom: 0;
}

.login1_2 {
  width: 604px;
  height: 239px;
  margin: 50px auto;
}

.login1_2_left {
  width: 332px;
  height: auto;
  float: left;
}

.login1_2_erro {
  width: 322px;
  height: 30px;
  border: 1px solid#FF4D42;
  background: rgba(255, 77, 66, 0.1);
  line-height: 30px;
  margin-bottom: 16px;
}

.login1_2_erro img {
  float: left;
  padding: 5px 9px;
}

.login1_2_login {
  width: 322px;
  height: 168px;
}

.inp {
  width: 210px;
  height: 40px;
  font-size: 14px;
  float: left;
  outline: 0;
  border: 0;
  margin: 0 5px;
}

.login1_2_tel {
  width: 100%;
  height: 40px;
  border: 1px solid #c7c7c7;
  margin-bottom: 16px;
}

.login1_2_tel p {
  width: 100px;
  height: 28px;
  float: right;
  border-left: 1px solid #c7c7c7;
  margin: 5px 0;
  line-height: 30px;
  text-align: center;
}

.login1_2_tel p a {
  color: #007bff;
}

.inpt {
  width: 312px;
  height: 38px;
  outline: 0;
  font-size: 14px;
  border: 0;
  margin: 0 5px;
}

.login1_2_right {
  float: right;
  background: #000;
  width: 228px;
  height: 239px;
}

.login1_2_denglu {
  width: 100%;
  height: 40px;
  background: #007bff;
  margin-top: 32px;
}

.login1_2_denglu p {
  text-align: center;
  font-size: 16px;
  line-height: 40px;
}

.login1_2_denglu p a {
  color: #fff;
}

.xiala {
  width: 100px;
  text-align: center;
  margin-top: -5px;
}

.dialog {
  width: 28%;
  height: auto;
  margin: 0 auto;
  text-align: center;
}

.dialog p {
  text-align: center;
  margin: 20px 0;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/view/Home.vue